import {Pipe, PipeTransform} from '@angular/core';
import {Discount} from "../../Models/discount";
import {DiscountServiceService} from "../../Services/discount-service.service";

@Pipe({
    name: 'remainingSeconds',
    standalone: false
})

export class remainingSecondsPipe implements PipeTransform {

  constructor(private discountServiceService:DiscountServiceService) {

  }

  public transform(discount: Discount) {

    if (discount){
      const endPromoDate = this.discountServiceService.convertUTCDateToLocalAlgOffset(new Date(discount.endingDate));

      const dateNow = new Date();
      const diffrenteTimeInSeconds = Math.floor((endPromoDate.getTime() - dateNow.getTime()));

      if (diffrenteTimeInSeconds <= 0) {
        return null;
      }else{
        const seconds = diffrenteTimeInSeconds / 1000 ;
        return seconds;
      }
    }








  }
}
